// removed by extract-text-webpack-plugin
module.exports = {"Apple":"VaeQ2KUfBQ2jsvQ2XrhXa","Dell":"_1ysq0ZHFJk1afLbruD5mft","Abbott":"_2ydf79pW_HEiNhbS1rsXxP","Gap":"MsC2OhdyTB04FbkjNqYyt","Allstate":"HF18u7WkZv4K34HWHy_5s","Asurion":"UeXFlFLMzV4vCXTFPNQTI","Invitae":"_2to_WR_-PVRmhkVBjEdS_h","JWE":"_1pBcX8ko9Zxei98cp0mMxe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Invoices/statuses.scss
// module id = BgeU
// module chunks = 12